/**
 * Export d'une liste affichee, en classeur Excel (.xlsx).
 *
 * Il exporte CE QUI EST FILTRE, pas la table entiere : c'est le sens de
 * l'action la ou elle se trouve, au bout de la barre de filtres.
 *
 * XLSX plutot que CSV depuis le 2026-09-29 : le CSV demandait deux
 * concessions a Excel en francais (point-virgule, BOM) et laissait
 * les montants en texte. Un classeur porte des NOMBRES — Excel calcule
 * dessus sans conversion — et des accents qui ne se cassent pas.
 *
 * La bibliotheque se charge A LA DEMANDE : quatre cents kilo-octets
 * qu'aucun ecran n'a besoin d'embarquer avant le premier clic.
 */
export type CelluleExport = string | number | null | undefined;

export async function exporterTableau(
  nomFichier: string,
  entetes: string[],
  lignes: CelluleExport[][],
): Promise<void> {
  const XLSX = await import('xlsx');
  const feuille = XLSX.utils.aoa_to_sheet([
    entetes,
    ...lignes.map((ligne) => ligne.map((v) => (v === null || v === undefined ? '' : v))),
  ]);
  // Une largeur par colonne, sur le plus long contenu (borne a 60) :
  // sans elle, Excel ouvre tout en colonnes de huit caracteres.
  feuille['!cols'] = entetes.map((entete, i) => ({
    wch: Math.min(
      60,
      Math.max(entete.length, ...lignes.map((l) => String(l[i] ?? '').length)) + 2,
    ),
  }));
  const classeur = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(classeur, feuille, 'Export');
  XLSX.writeFile(classeur, `${nomFichier}-${new Date().toISOString().slice(0, 10)}.xlsx`);
}

/**
 * Date ISO vers « JJ/MM/AAAA », vide si absente.
 *
 * `formaterDate` rendrait « — » pour une date manquante : lisible a
 * l'ecran, faux dans une colonne de tableur.
 */
export function dateExport(valeur: string | null | undefined): string {
  if (!valeur) return '';
  const [annee, mois, jour] = valeur.slice(0, 10).split('-');
  return jour && mois && annee ? `${jour}/${mois}/${annee}` : '';
}

/** Montant en centimes vers un NOMBRE en euros : Excel doit pouvoir calculer. */
export function montantExport(centimes: number): number {
  return Math.round(centimes) / 100;
}
